import type { DealStatus, DealPriority, DealStage } from '@/types';
import { STAGE_LABELS } from '@/types';

export function StatusDot({ status }: { status: DealStatus }) {
  const colors: Record<DealStatus, string> = {
    active: 'bg-green-400',
    slowing: 'bg-yellow-400',
    no_activity: 'bg-red-400',
  };
  const labels: Record<DealStatus, string> = {
    active: 'Active',
    slowing: 'Slowing',
    no_activity: 'No Activity',
  };
  return (
    <span className="inline-flex items-center gap-1.5 text-xs">
      <span className={`w-2 h-2 rounded-full ${colors[status]}`} />
      {labels[status]}
    </span>
  );
}

export function StatusBadge({ status }: { status: DealStatus }) {
  const styles: Record<DealStatus, string> = {
    active: 'bg-green-500/15 text-green-400 border-green-500/25',
    slowing: 'bg-yellow-500/15 text-yellow-400 border-yellow-500/25',
    no_activity: 'bg-red-500/15 text-red-400 border-red-500/25',
  };
  const labels: Record<DealStatus, string> = {
    active: 'Active',
    slowing: 'Slowing',
    no_activity: 'No Activity',
  };
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold border ${styles[status]}`}>
      {labels[status]}
    </span>
  );
}

export function PriorityBadge({ priority }: { priority: DealPriority }) {
  const styles: Record<DealPriority, string> = {
    hot: 'bg-red-500/10 text-red-400 border-red-500/20',
    warm: 'bg-yellow-500/10 text-yellow-400 border-yellow-500/20',
    cold: 'bg-blue-500/10 text-blue-400 border-blue-500/20',
  };
  return (
    <span className={`inline-block px-2 py-0.5 rounded text-xs font-medium border capitalize ${styles[priority]}`}>
      {priority}
    </span>
  );
}

export function StageBadge({ stage }: { stage: DealStage }) {
  const styles: Record<DealStage, string> = {
    new: 'bg-blue-500/10 text-blue-400',
    contacted: 'bg-cyan-500/10 text-cyan-400',
    demo_done: 'bg-purple-500/10 text-purple-400',
    test_drive: 'bg-orange-500/10 text-orange-400',
    closing: 'bg-yellow-500/10 text-yellow-400',
    sold: 'bg-green-500/10 text-green-400',
  };
  return (
    <span className={`inline-block px-2 py-0.5 rounded text-xs font-medium ${styles[stage]}`}>
      {STAGE_LABELS[stage]}
    </span>
  );
}
